const ssnRegex = /^(?!(000|666|9))\d{3}(-| |)(?!00)\d{2}(-| |)(?!0000)\d{4}$/;

export default ssnRegex;
